import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=263b5ef4&scoped=true&"
import script from "./banner.vue?vue&type=script&lang=js&"
export * from "./banner.vue?vue&type=script&lang=js&"
import style0 from "./banner.vue?vue&type=style&index=0&id=263b5ef4&scoped=true&lang=less&"
import style1 from "./banner.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263b5ef4",
  null
  
)

export default component.exports